
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ZSplitDropdownButtonV2',
  props: {
    dividerColor: {
      type: String,
      default: 'slate-400'
    },
    dividerHeight: {
      type: String,
      default: 'h-full'
    }
  }
})
